/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialButton from 'app/components/common/SocialButton.jsx';
import DropDown from 'app/components/common/DropDown.jsx';
import FilterItem from 'app/components/DropDownItems/FilterItem.jsx';
import GenericItem from 'app/components/DropDownItems/GenericItem.jsx';
import SocialHeader from 'app/components/Headers/SocialHeader.jsx';
import SocialModalHeader from 'app/components/SocialModal/SocialModalHeader.jsx';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import classnames from 'classnames';
import RetweetPanel from 'app/components/common/RetweetPanel.jsx';
import * as _ from 'underscore';


class SocialSelection extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			dropDownFilter: false,
			dropDownSort: false,
			filterLabel: 'All Socials',
			sortLabel: 'Sort A - Z',
			showTwitterTray: false,
			twitters: [],
			listModeShort: true,
		};

		this.handleSocialClick = this.handleSocialClick.bind(this);
		this.filterButtonClick = this.filterButtonClick.bind(this);
		this.filterItemHandler = this.filterItemHandler.bind(this);
		this.searchHandler = this.searchHandler.bind(this);
		this.searchFocusHandler = this.searchFocusHandler.bind(this);
		this.sortButtonClick = this.sortButtonClick.bind(this);
		this.sortHandler = this.sortHandler.bind(this);
		this.onConnect = this.onConnect.bind(this);
		this.createFeedHandler = this.createFeedHandler.bind(this);
		this.findTwitters = this.findTwitters.bind(this);
		this.resetHandler = this.resetHandler.bind(this);

	}

	componentDidMount() {

		let showTwitterTray = false,
			twitters = this.findTwitters(this.props),
			twitterCount = 0,
			constants = this.props.app.config.constants;

		for (let i = 0; i < this.props.selectedSocials.length; ++i) {
			let id = this.props.selectedSocials[i];
			let social = _.find(twitters, (social) => {
				return social.id == this.props.selectedSocials[i];
			});
			if (social) {
				++twitterCount;
			}
		}

		// determine if the tray should be visible right away
		// in the modal context. if there's more than 1 twitter or if the only twitters are
		// retweeters
		if (twitterCount > 1) {
			showTwitterTray = true;
		}

		if (twitterCount >= 1) {
			let isMasterOutput = false;
			for (var i = 0; i < this.props.outputs.length; ++i) {
				var output = this.props.outputs[i];
				if (output.social.psID == constants.POST_SVC_TWITTER && output.role == constants.OR_ROLE_NORMAL) {
					isMasterOutput = true;
				}
			}
			if (this.props.outputs.length > 0 && !isMasterOutput) {
				showTwitterTray = true;
			}
		}

		if (this.props.serviceId !== constants.POST_SVC_TWITTER) {
			showTwitterTray = false;
		}

		this.setState({
			showTwitterTray,
			twitters
		});

	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.socials.list.length != prevProps.socials.list.length) {
			this.setState({
				twitters: this.findTwitters(this.props)
			});
		}

		if (prevProps.mainTweeter != this.props.mainTweeter && this.props.mainTweeter == 0) {
			this.setState({
				showTwitterTray: false
			});
		}


	}

	findTwitters(props) {
		let constants = this.props.app.config.constants,
			twitters = [];

		for (var i = 0; i < props.socials.list.length; ++i) {
			if (props.socials.list[i].psID == constants.POST_SVC_TWITTER) {
				twitters.push(props.socials.list[i]);
			}
		}

		return twitters;

	}

	handleSocialClick(e) {
		let constants = this.props.app.config.constants,
			showTwitterTray = false,
			twitterCount = 0;

		if (e.currentTarget.dataset.type == constants.POST_SVC_TWITTER) {
			if (this.props.selectedSocials.indexOf(e.currentTarget.dataset.id) === -1) {
				twitterCount = 1;
			} else {
				twitterCount = -1;
			}

			for (var i = 0; i < this.props.selectedSocials.length; ++i) {
				var id = this.props.selectedSocials[i];
				var social = _.find(this.state.twitters, function (social) {
					return social.id == this.props.selectedSocials[i];
				}.bind(this));
				if (social && social.id !== parseInt(e.currentTarget.dataset.id)) {
					++twitterCount;
				}
			}

			if (e.currentTarget.dataset.id == this.props.mainTweeter) {
				if (twitterCount > 1 && this.props.context !== 'bulk-modal') {
					this.props.resetTwitters();
					return;
				}
			}

			if (twitterCount > 1 && this.props.twitterInput === false) {
				showTwitterTray = true;
			}

			this.setState({
				showTwitterTray
			});

		}

		if (e.currentTarget.dataset.type == constants.POST_SVC_YOUTUBE) {
			let youTubeCount = 0,
				selectedId = parseInt(e.currentTarget.dataset.id);

			this.props.socials.list.map((social) => {
				if (social.psID === constants.POST_SVC_YOUTUBE && this.props.selectedSocials.indexOf(social.id) !== -1) {
					++youTubeCount;
				}
			});

			if (this.props.selectedSocials.indexOf(selectedId) === -1 && youTubeCount) {
				return;
			}
		}

		if (_.isFunction(this.props.socialClickHandler)) {
			this.props.socialClickHandler.call(this, e);
		}

	}

	filterButtonClick() {
		let dropDownSort = this.state.dropDownSort;

		if (!this.state.dropDownFilter && dropDownSort) {
			dropDownSort = false;
		}

		this.setState({
			dropDownFilter: (this.state.dropDownFilter) ? false : true,
			dropDownSort
		});
	}

	sortButtonClick() {
		let dropDownFilter = this.state.dropDownFilter;

		if (!this.state.dropDownSort && dropDownFilter) {
			dropDownFilter = false;
		}

		this.setState({
			dropDownFilter,
			dropDownSort: (this.state.dropDownSort) ? false : true
		});

	}

	filterItemHandler(social, e) {
		this.props.filterHandler(e, social.type);

		this.setState({
			filterLabel: social.name,
			dropDownFilter: false,
			resetSearch: true
		});

	}

	searchHandler(e, search) {

		this.setState({
			filterLabel: 'All Socials'
		});

		this.props.searchHandler(e, search);

	}

	sortHandler(sort, e) {
		let nextLabel = this.state.sortLabel;

		if (sort.key === 'postGroup') {
			this.props.showPostGroupModal();
		} else {
			nextLabel = sort.name;
			if (sort.key === 'type') {
				this.props.sortStore('socials', 'psID', 'ASC');
			} else {
				let dir = "ASC";
				if (sort.key === 'z-a') {
					dir = "DESC";
				}
				this.props.sortStore('socials', 'name', dir);
			}
		}

		this.setState({
			sortLabel: nextLabel,
			dropDownSort: false
		});
	}

	searchFocusHandler(e) {

		this.setState({
			resetSearch: false
		});

	}

	resetHandler(id) {
		if (id === "social-filter") {
			this.setState({
				dropDownFilter: false
			});
		} else if (id === 'social-sort') {
			this.setState({
				dropDownSort: false
			});
		}
	}

	onConnect(e) {

		this.props.filterHandler(e, '');
		this.setState({
			filterLabel: 'All Socials',
			resetSearch: true
		});

		this.props.connectHandler();

	}

	createFeedHandler() {
		this.props.connectHandler('connect');
	}

	render() {
		let saveClass = classnames(
			'btn-primary btn-modal',
			{
				'active': this.props.isDirty
			}
		),
			saveHandler = null,
			DropDownFilter = null,
			DropDownSort = null,
			actionButton = null,
			selectionHeader = null,
			connectButton = null,
			selectionListClass = 'social-selection-list',
			socialHeader = null,
			twitterTray = null,
			constants = this.props.app.config.constants,
			socials = (this.props.socials.filteredList.length) ? this.props.socials.filteredList : this.props.socials.list;

		if (this.props.isDirty) {
			saveHandler = this.props.saveHandler;
		}

		if (this.state.dropDownFilter) {
			DropDownFilter = (
				<DropDown
					id="social-filter"
					items={this.props.socials.counts}
					itemElement={FilterItem}
					clickHandler={this.filterItemHandler}
					dropDownClass="filter-dd"
					resetHandler={this.resetHandler} />
			);
		}

		if (this.state.dropDownSort) {
			DropDownSort = (
				<DropDown
					id="social-sort"
					items={[
						{ key: 'a-z', name: 'Sort A - Z' },
						{ key: 'z-a', name: 'Sort Z - A' },
						{ key: 'type', name: 'Sort By Type' },
						{ key: 'postGroup', name: 'Choose Posting Group' }
					]}
					itemElement={GenericItem}
					clickHandler={this.sortHandler}
					dropDownClass="sort-dd short"
					resetHandler={this.resetHandler} />
			);
		}

		if (["modal", "bulk-modal", "list-add", "post-groups"].indexOf(this.props.context) === -1) {
			selectionHeader = (
				<div className="social-selection-header">
					{this.props.topButton}
					<div className="social-selection-headline">
						Which social channels should we share to?
					</div>
					Share to <span className="number-callout active">{this.props.selectedSocials.length}</span> of your <span className="number-callout">{this.props.socials.list.length}</span> Socials
				</div>
			);
		}

		if (this.props.context === "modal" || this.props.context === 'list-add') {
			selectionListClass += " in-modal";
			actionButton = (
				<div className="control save">
					<div className={saveClass} onClick={saveHandler}>update</div>
				</div>
			);
			if (this.props.serviceId === constants.POST_SVC_MASTODON) {
				connectButton = (
					<li className="list-item social" key={this.props.socials.list.length + 1} role="button" aria-label="connect new">
						<SocialButton
							app={this.props.app}
							connect={true}
							connectAction={() => {
								this.props.switchView('providehandle');
							}}
							direct={true}
							serviceId={this.props.serviceId} />
					</li>
				);
			} else {
				connectButton = (
					<li className="list-item social" key={this.props.socials.list.length + 1} role="button" aria-label="connect new">
						<SocialButton
							app={this.props.app}
							connect={true}
							connectAction={ConnectMixin.connectService.bind(this)}
							direct={true}
							serviceId={this.props.serviceId} />
					</li>
				);
			}

		} else if (this.props.context === "input") {
			actionButton = (
				<div className="control new" onClick={this.onConnect} role="button" aria-label="connect new">
					<span className="va-helper"></span>
					<i className="fa fa-plus-square new-icon"></i> Connect Social
				</div>
			);
			connectButton = (
				<li className="list-item social" key={this.props.socials.list.length + 1} role="button" aria-label="connect new">
					<SocialButton
						app={this.props.app}
						connect={true}
						connectAction={this.props.connectHandler} />
				</li>
			);
		} else if (this.props.context === "stats" || this.props.context === "queue" || this.props.context === "post-modal") {
			selectionHeader = null;
			if (this.props.context === "post-modal") {
				selectionListClass += " in-modal";
			}
		}

		if (this.props.displayHeader) {
			if (this.props.context === 'modal' || this.props.context === 'list-add') {
				socialHeader = (
					<SocialModalHeader
						{...this.props}
						serviceId={this.props.serviceId}
						searchHandler={this.searchHandler}
						focusHandler={this.searchFocusHandler}
						resetSearch={this.state.resetSearch}
						connectAction={this.props.connectHandler}
						switchView={this.props.switchView}
						recordPath={this.props.setPath}
						singleTwitter={this.props.singleTwitter}
						twitterMaxedOut={this.props.twitterMaxedOut} />
				);
			} else {
				let showFilter = false;
				if (this.props.context === 'queue' || this.props.context === 'bulk-modal') {
					showFilter = true;
				}
				if (this.props.context === "input") {

					socialHeader = (
						<SocialHeader
							{...this.props}
							showFilter={showFilter}
							searchCallback={this.searchHandler}
							actionButton={actionButton}
							filterDropdown={DropDownFilter}
							context={this.props.context}
							focusHandler={this.searchFocusHandler}
							resetSearch={this.state.resetSearch}
							serviceId={this.props.serviceId}
							filterLabel={this.state.filterLabel}
							filterButtonCallback={this.filterButtonClick}
							sortDropdown={DropDownSort}
							sortLabel={this.state.sortLabel}
							sortButtonCallback={this.sortButtonClick} />
					);
				} else {
					socialHeader = (
						<SocialHeader
							{...this.props}
							showFilter={showFilter}
							searchCallback={this.searchHandler}
							actionButton={actionButton}
							filterDropdown={DropDownFilter}
							context={this.props.context}
							focusHandler={this.searchFocusHandler}
							resetSearch={this.state.resetSearch}
							serviceId={this.props.serviceId}
							filterLabel={this.state.filterLabel}
							filterButtonCallback={this.filterButtonClick} />
					);
				}

			}

		}

		if (this.props.twitterMaxedOut) {
			connectButton = null;
		}

		if (this.state.showTwitterTray && !this.props.twitterInput) {
			twitterTray = (
				<RetweetPanel
					{...this.props}
					selectedSocials={this.props.selectedSocials}
					mainTweeter={this.props.mainTweeter}
					setMainTweeter={this.props.setMainTweeter}
					context={this.props.context}
					socialClickHandler={this.props.socialClickHandler}
					handleSocialClick={this.handleSocialClick} />
			);
		}

		let listClass = 'detail-list clearfix',
			listHeightToggle = null,
			listToggleLabel = (this.state.listModeShort) ? 'show more' : 'show less';

		if (this.props.toggleListHeight) {
			if (this.state.listModeShort) {
				listClass += ' short';
			}
			listHeightToggle = (
				<div className="socials-list-toggle">
					<div className="socials-list-button" onClick={(e) => {
						let nextToggleState = this.state.listModeShort ? false : true;

						this.setState({
							listModeShort: nextToggleState
						});
					}}>
						{listToggleLabel}
					</div>
				</div>
			);
		}

		let routeCreateError = null;
		if (this.props.routeCreateError !== undefined && this.props.routeCreateError !== null) {
			routeCreateError = (
				<div className="social-settings-reminder route-create-error">
					{this.props.routeCreateError}
				</div>
			);
		}

		return (
			<div>
				{socialHeader}
				{routeCreateError}
				<div className={selectionListClass}>
					{selectionHeader}
					<ul className={listClass}>
						{socials.map(function (social, i) {
							let unselected = (this.props.selectedSocials.find((item) => { return social.id === item; }) === undefined) ? true : false,
								buttonClass = 'list-item social',
								customSubLabel = '',
								percentFull = 0,
								constants = this.props.app.config.constants,
								retweet = false,
								clickHandler = this.handleSocialClick,
								rolloverInfo = null,
								inputIds = [];

							if (this.props.route !== undefined && this.props.route.inputs.length) {
								for (let i = 0; i < this.props.route.inputs.length; ++i) {
									let input = this.props.route.inputs[i];
									if (input.externalID !== undefined) {
										inputIds.push(input.externalID);
									}
								}
							}

							if (inputIds.indexOf(social.externalID) !== -1) {
								rolloverInfo = (
									<div className="social-tooltip">
										Selecting this output would create a posting loop.
									</div>
								);
								clickHandler = null;
							}


							if (this.props.context === "post-modal" && (social.psID == constants.POST_SVC_REDDIT)) {
								rolloverInfo = (
									<div className="social-tooltip">
										Reddit is not currently available for direct posting.
									</div>
								);
								clickHandler = null;
							}

							if (this.props.context === 'post-modal' && (social.psID == constants.POST_SVC_TWITTER)) {
								if (this.props.twitterCount && unselected) {
									rolloverInfo = (
										<div className="social-tooltip">
											Due to Twitter policy, only a single twitter may be selected.
										</div>
									);
								}
							}

							if (social.psID === constants.POST_SVC_YOUTUBE) {
								let youTubeCount = 0;
								this.props.socials.list.map((social) => {
									if (social.psID === constants.POST_SVC_YOUTUBE &&
										this.props.selectedSocials.indexOf(social.id) !== -1) {
										++youTubeCount;
									}
								});
								if (youTubeCount > 0 && unselected) {
									rolloverInfo = (
										<div className="social-tooltip">
											Choose one YouTube channel per feed.
										</div>
									);
								}
							}

							if (this.props.onlyDisplaySelectedSocials) {
								if (unselected) {
									return null;
								}
							}

							if (this.props.mainTweeter != 0 && this.props.mainTweeter != social.id && social.psID == constants.POST_SVC_TWITTER) {
								retweet = true;
							}

							if (this.props.twitterInput && social.psID == constants.POST_SVC_TWITTER) {
								retweet = true;
							}

							if (this.props.singleTwitter === true) {
								retweet = false;
							}

							if (this.props.context === 'queue') {
								buttonClass += " queue";
								percentFull = (parseInt(social.qCount, 10) / parseInt(this.props.user.perms.resources.qLimit, 10)) * 100;
								if (isNaN(percentFull)) {
									percentFull = 0;
								}
								customSubLabel = percentFull.toFixed(0) + "% full";
							}

							return (
								<li key={i} onClick={clickHandler} data-id={social.id} data-type={social.psID} className={buttonClass} role="button" aria-label={social.name}>
									<SocialButton
										app={this.props.app}
										social={social}
										unselected={unselected}
										context={this.props.context}
										selected={!unselected}
										customSubLabel={customSubLabel}
										retweet={retweet}
										user={this.props.user} />
									{rolloverInfo}
								</li>
							)
						}, this)}
						{connectButton}
					</ul>
					{listHeightToggle}
				</div>
				{twitterTray}
			</div>
		);
	}
};

SocialSelection.displayName = "SocialSelection";

SocialSelection.propTypes = {
	displayHeader: PropTypes.bool,
	socials: PropTypes.object,
	outputs: PropTypes.array,
	searchHandler: PropTypes.func,
	filterHandler: PropTypes.func,
	socialClickHandler: PropTypes.func,
	saveHandler: PropTypes.func,
	isDirty: PropTypes.bool,
	selectedSocials: PropTypes.array,
	context: PropTypes.string,
	connectHandler: PropTypes.func,
	servcieId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	twitterInput: PropTypes.bool,
	onlyDisplaySelectedSocials: PropTypes.bool,
	singleTwitter: PropTypes.bool,
	mainTweeter: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	setMainTweeter: PropTypes.func,
	toggleListHeight: PropTypes.bool
};

SocialSelection.defaultProps = {
	displayHeader: true,
	socials: {},
	outputs: [],
	routeId: 0,
	socialClickHandler: null,
	saveHandler: null,
	isDirty: false,
	selectedSocials: [],
	context: "modal",
	connectHandler: null,
	resetSearch: false,
	serviceId: 0,
	twitterInput: false,
	onlyDisplaySelectedSocials: false,
	singleTwitter: false,
	mainTweeter: 0,
	setMainTweeter: () => { },
	topButton: null,
	toggleListHeight: false
};

export default SubscriptionModule(SocialSelection);
